import React, {  } from 'react';
import {Field, ErrorMessage } from 'formik';
import  {Box, Alert} from '@mui/material/';


function DropDown(props) {

    const { label, name, optionObject } = props.symptom
    
    return (
        <Box sx={{border:"solid", borderColor:"grey.300",borderRadius:"10px", width:"auto", margin:1}}>

        <label htmlFor={name}> {label} </label>
        <Field as = 'select'className="modalInputBox" id={name}  name={name}  >

        {optionObject.map(option=>{
            return (
                <option key = {option.key} value = {option.value}>
                    {option.key}
                </option>
                )
        })}
       </Field>
       <ErrorMessage name={name} >
            {errorMsg => <Alert severity='error' >{errorMsg}</Alert>}
          </ErrorMessage>
        </Box>
     
     );
}

export default DropDown;
